<div class="events-wrapper">
  <div class="events-filter">
    <button
      type="button"
      class="events-filter__tab"
      [class.active]="!showDeleted()"
      (click)="toggleDeleted(false)"
    >
      Active
    </button>
    <button
      type="button"
      class="events-filter__tab"
      [class.active]="showDeleted()"
      (click)="toggleDeleted(true)"
    >
      Deleted
    </button>
  </div>

  <div class="events-scroll" #scrollViewport>
    <div *ngIf="(events$ | async) as events">
      @for( event of events; let last = $last; track event._id){
        <div [ngClass]="{ 'mb-1': !last, 'unread': !event?.isRead }" class="event-item" (click)="markAsRead(event)">
          <div class="flex items-center justify-between">
            <div class="flex items-center action-buttons">
              <a
                *ngIf="event.isRead"
                [routerLink]="[]"
                class="cursor-pointer mr-2"
                title="Mark As Unread"
                (click)="markAsUnread(event)"
              >
                <i class="fa-solid fa-eye-low-vision text-blue-500 text-base"></i>
              </a>
              <a
                *ngIf="event.resourceId"
                [routerLink]="[]"
                title="Open Resource"
                (click)="redirect(event)"
              >
                <i class="fas fa-external-link-alt text-blue-500 text-base"></i>
              </a>
            </div>

            @if(!showDeleted()){
              <app-btn-confirm  (onConfirm)="deleteEvent(event)"></app-btn-confirm>
            }

          </div>

          <div class="text-black text-base event-block" [innerHTML]="event?._contentHTML || event?.content"></div>

          <span class="text-black text-sm" *ngIf="!event.content || event.followUpType === 'Note'"
          (click)=" event.notifExpand
              ? (event.notifExpand = 0)
              : (event.notifExpand = 1)
          ">
            {{ event?.followUpType }}
          </span>

          <div class="flex items-center">
            <div class="text-black text-base font-semibold">
              {{ $safeNavigationMigration(event?.followUp) | date: 'short' }}
            </div>


            <span  class="badge-black text-xs ml-1"
              title="{{ event?.creator?.name }}">{{ $safeNavigationMigration(event?.creator?.name) | shrinkName }}</span>
          </div>
        </div>
      }

      @if(!events.length && !loading()){
        <div class="events-empty">
          {{ showDeleted() ? 'No deleted notifications' : 'No notifications' }}
        </div>
      }
    </div>

    @if(loading()){
      <div class="events-loader">
        <i class="fas fa-circle-notch fa-spin text-blue-500"></i>
      </div>
    } @else if(hasMore()){
      <button type="button" class="events-load-more" (click)="loadMore()">
        Load more
      </button>
    }

    <!-- Watched by an IntersectionObserver: entering the viewport pulls the next page -->
    <div class="events-sentinel" #scrollSentinel></div>
  </div>
</div>
